import { Box } from '@chakra-ui/react';
import Cookies from 'universal-cookie';
import moment from 'moment';

import { TextBold, TextMedium } from 'UiKit/typography';
import ClockTime from 'UiKit/clock-time';
import { headText } from 'Const/monitoring/view';
import { Condition } from 'Component/others';

import HeadSkeleton from 'View/monitoring/component/skeleton/head-skeleton';

import styles from './styles.module.css';

const Head = ({ isFetching, t }) => {
  const cookie = new Cookies();
  const userName = cookie.get('username');

  const welcomingText = headText?.handleWelcomingText({ userName, t });
  const dateNow = moment().format('dddd, DD MMMM YYYY');

  return (
    <Condition statement={!isFetching} fallback={<HeadSkeleton />}>
      <Box className={styles['head__container']}>
        <TextBold className={styles['welcoming__text']}>{welcomingText}</TextBold>
        <TextMedium className={styles['date-time__text']}>
          {dateNow} · <ClockTime />
        </TextMedium>
      </Box>
    </Condition>
  );
};

export default Head;
